module.exports = __webpack_public_path__ + "static/img/Group593.34cd37c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Group593.png
// module id = 4wNm
// module chunks = 1